var Assam = "阿萨姆邦";
var Bihar = "比哈尔邦";
var Chandigarh = "昌迪加尔";
var Chhattisgarh = "恰蒂斯加尔邦";
var Delhi = "德里区";
var Goa = "果阿";
var Gujarat = "古吉拉特邦";
var Haryana = "哈里亚纳邦";
var Jharkhand = "贾坎德邦";
var Karnataka = "卡纳塔克邦";
var Kerala = "喀拉拉邦";
var Lakshwadeep = "拉克沙群岛";
var Maharashtra = "马哈拉施特拉邦";
var Manipur = "曼尼普尔区";
var Meghalaya = "梅加拉亚邦";
var Mizoram = "米佐拉姆邦";
var Nagaland = "那加兰邦";
var Orrisa = "奥里萨邦";
var Puducherry = "本地治里";
var Punjab = "旁遮普";
var Rajasthan = "拉贾斯坦邦";
var Sikkim = "锡金";
var Telangana = "特伦甘纳邦";
var Tripura = "特里普拉邦";
var Uttrakhand = "北阿坎德邦";
var INStates = {
	"Andaman and Nicobar Islands": "安达曼和尼科巴群岛",
	"Andhra Pradesh": "安得拉邦",
	"Arunachal Pradesh": "阿鲁纳恰尔邦",
	Assam: Assam,
	Bihar: Bihar,
	Chandigarh: Chandigarh,
	Chhattisgarh: Chhattisgarh,
	"Dadra & Nagar Haveli": "达德拉和纳加尔哈维利",
	"Daman & Diu": "达曼和第乌",
	Delhi: Delhi,
	Goa: Goa,
	Gujarat: Gujarat,
	Haryana: Haryana,
	"Himachal Pradesh": "方喜玛偕尔邦",
	"Jammu and Kashmir": "查谟和克什米尔",
	Jharkhand: Jharkhand,
	Karnataka: Karnataka,
	Kerala: Kerala,
	Lakshwadeep: Lakshwadeep,
	"Madhya Pradesh": "中央邦",
	Maharashtra: Maharashtra,
	Manipur: Manipur,
	Meghalaya: Meghalaya,
	Mizoram: Mizoram,
	Nagaland: Nagaland,
	Orrisa: Orrisa,
	Puducherry: Puducherry,
	Punjab: Punjab,
	Rajasthan: Rajasthan,
	Sikkim: Sikkim,
	"Tamil Nadu": "泰米尔纳德邦",
	Telangana: Telangana,
	Tripura: Tripura,
	"Uttar Pradesh": "北方邦",
	Uttrakhand: Uttrakhand,
	"West Bengal": "西孟加垃邦"
};

export { Assam, Bihar, Chandigarh, Chhattisgarh, Delhi, Goa, Gujarat, Haryana, Jharkhand, Karnataka, Kerala, Lakshwadeep, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Orrisa, Puducherry, Punjab, Rajasthan, Sikkim, Telangana, Tripura, Uttrakhand, INStates as default };
